import { GoogleOAuthProvider } from '@react-oauth/google';

// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = 'YOUR_GOOGLE_CLIENT_ID_HERE'; // Replace with your actual Google Client ID

// Google OAuth Provider component
export const GoogleAuthProvider = ({ children }) => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  );
};

// Function to handle Google sign-in success
export const handleGoogleSignIn = async (credentialResponse, navigate, setIsLoggedIn) => {
  try {
    // Decode the JWT token to get user information
    const decodedToken = decodeJwt(credentialResponse.credential);
    
    // Extract user information
    const userInfo = {
      email: decodedToken.email,
      name: decodedToken.name,
      firstName: decodedToken.given_name,
      lastName: decodedToken.family_name,
      picture: decodedToken.picture,
      id: decodedToken.sub
    };

    // Store user info in localStorage (for demo purposes)
    localStorage.setItem('user', JSON.stringify(userInfo));
    localStorage.setItem('isLoggedIn', 'true');

    // Set logged in state
    setIsLoggedIn(true);

    // Navigate to dashboard
    navigate('/dashboard');
    
    return { success: true, user: userInfo };
  } catch (error) {
    console.error('Google sign-in error:', error);
    return { success: false, error: error.message };
  }
};

// Function to handle Google sign-up
export const handleGoogleSignUp = async (credentialResponse, navigate) => {
  try {
    // Decode the JWT token to get user information
    const decodedToken = decodeJwt(credentialResponse.credential);
    
    // Extract user information
    const userInfo = {
      email: decodedToken.email,
      name: decodedToken.name,
      firstName: decodedToken.given_name,
      lastName: decodedToken.family_name,
      picture: decodedToken.picture,
      id: decodedToken.sub
    };

    // Store user info in localStorage (for demo purposes)
    localStorage.setItem('user', JSON.stringify(userInfo));
    localStorage.setItem('isLoggedIn', 'true');

    // Navigate to dashboard
    navigate('/dashboard');
    
    return { success: true, user: userInfo };
  } catch (error) {
    console.error('Google sign-up error:', error);
    return { success: false, error: error.message };
  }
};

// JWT decode function (basic implementation)
function decodeJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload);
}

// Error handler for Google OAuth
export const handleGoogleError = (error) => {
  console.error('Google OAuth Error:', error);
  // You can show a toast notification here
  return { success: false, error: 'Google sign-in failed. Please try again.' };
};
